import { DateOnly } from '@if/core/date'
import { Box, Card, CardContent, Typography } from '@mui/material'
import { BaseWorksheetForm } from '@src/components'
import { BaseWorksheetFormConfig } from '@src/components/WorksheetForm'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { CalculatorValues } from '../calculatorSchema'

interface CalculatorParametersFieldsProps {
  control: Control<CalculatorValues>
  config: BaseWorksheetFormConfig
  activationMaxDate: DateOnly
  // Standalone calculator hides the high-estimate flag (only shown in-app when the merchant supports it).
  isStandalone?: boolean
}

const CalculatorParametersFields = ({
  control,
  config,
  activationMaxDate,
  isStandalone = false,
}: CalculatorParametersFieldsProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="overline" color="text.secondary" gutterBottom>
          {t('calculator.parameters')}
        </Typography>
        <Box>
          <BaseWorksheetForm config={config}>
            <BaseWorksheetForm.AmountRequested control={control} />
            <BaseWorksheetForm.PaymentPlan control={control} />
            <BaseWorksheetForm.PaymentFrequency control={control} />
            <BaseWorksheetForm.ActivationDate control={control} maxDate={activationMaxDate} />
            <BaseWorksheetForm.FirstPaymentDate control={control} />
            <BaseWorksheetForm.Term control={control} />
            <BaseWorksheetForm.IncludeProtection control={control} />
            {!isStandalone && <BaseWorksheetForm.IsHighEstimate control={control} />}
          </BaseWorksheetForm>
        </Box>
      </CardContent>
    </Card>
  )
}

export default CalculatorParametersFields
